/** The 1:1 display canvas as a PNG data URL; this is what gets saved. */
export function exportCanvasPng(): string {
	// If the sketch never finished starting (the artwork failed to load) the
	// display canvas is empty, and saving it would overwrite the real artwork
	if (!window.editSketch?.sketchReady) throw new Error('The canvas is not ready yet.');
	const canvasId = window.displaySketch?.canvas?.id;
	const canvasElement = canvasId ? (document.getElementById(canvasId) as HTMLCanvasElement | null) : null;
	if (!canvasElement) throw new Error('The canvas is not ready yet.');
	return canvasElement.toDataURL('image/png');
}
